<template>
  <router-view></router-view>
</template>

<script setup>
	import { ref, onMounted, getCurrentInstance } from 'vue'
	import { storeToRefs } from 'pinia'
	import useStore from './stores/index.js'
	const { pagesize } = useStore()
	const { width, height } = storeToRefs(pagesize)
	
	onMounted(() => {
		window.onresize = () => {
			pagesize.resetPage(document.documentElement.clientWidth, document.documentElement.clientHeight)
		}
	})

</script>

<style>
html, body {margin: 0;padding: 0;font-size:14px;background: #eff1f8; text-decoration: none;}

::-webkit-scrollbar{/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
	width:5px;
	height:5px;
}
::-webkit-scrollbar:hover{
	width:8px;
}
::-webkit-scrollbar-thumb{/*定义滑块 内阴影+圆角*/
	border-radius: 4px;
	background-color: #0002;
}
::-webkit-scrollbar-track{/*定义滚动条轨道 内阴影+圆角*/
	border-radius: 4px;
	background-color: #FFF;    
}
.formulabox span:focus{border: none;outline: none;}
.formulabox .fx {color: #770088;}
.formulabox .field {color:#008dcd; background-color: #ebf5ff;border-radius: 3px;}
.formulabox .symbol {color:#333333;}
.formulabox .number {color:#097c25;}
.formulabox .string {color:#b42d2d;}
.formulabox .temp {color: #ff0000;}

.chartbox{ margin: 5px;padding: 10px;background-color: #ffffff;border-radius: 5px;box-shadow:#0002 1px 1px 3px;transition:0.3s;position:relative;}
.chartbox:hover{box-shadow:#0004 1px 1px 6px ;}
.chartbox .chart-title{margin-bottom:8px;}



.qmytable {border: 1px solid #ddd;border-spacing: 0px;border-collapse: collapse;min-width:100%;font-size: 12px;text-align:left;color: #666666;}
.qmytable thead{position:sticky;top:0;background: #f5f7fa;z-index:2;}
.qmytable tbody{background: #fff;}
.qmytable tr th {vertical-align:middle;word-break: keep-all;border: 1px solid #ddd;text-align: center;vertical-align: middle;font-size: 13px;color: #666666;white-space: nowrap;padding: 5px 10px;background-color: #f5f5f5;}
.qmytable tr td {word-break: keep-all;border: 1px solid #ddd;font-size: 12px;color: #666666;background-color: #ffffff;white-space: nowrap;padding: 5px 10px;}
.qmytable tr th div, .qmytable tr td div {margin: 0;}
.qmytable tr th.opecol, .qmytable tr td.opecol {position: sticky;right: 0;z-index: 3;background-color: #fcfcfc;width: 200px;}
.qmytable tr td.opecol .el-button {margin: 2px 2px 2px 2px;}
/* .qmytable tr th div, .qmytable tr td div {display: inline-block; } */
/* 弹窗样式修改 -S */
/* 标题栏背景颜色配置 */
/* 
.el-dialog .el-dialog__header{margin:0;background:#5b5877;padding:15px;}
.el-dialog .el-dialog__header .el-dialog__title{color:#fff}
.el-dialog .el-dialog__header .el-dialog__headerbtn{top:4px;right:4px;width:46px;height:46px;border-radius:3px;}
.el-dialog .el-dialog__header .el-dialog__headerbtn:hover{background:#fff3;}
.el-dialog .el-dialog__header .el-dialog__headerbtn:hover .el-dialog__close{color:#fff;}
*/

.el-dialog .el-dialog__header{margin:0;}
.el-dialog .el-dialog__body{padding:5px 15px;}
.el-dialog .el-dialog__footer{padding:15px;}
/* 弹窗样式修改 -E */
</style>
